import FeatureRequestRepositoryInterface from "@/services/Bug-report/Feature-request/Feature-request/interfaces";
import {
  FeatureRequestEntity,
  CreateFeatureRequestDTO,
  CreateFeatureRequestResponseDTO, UpdateFeatureRequestDTO, BugReportEntity,
} from "@fenix/bug-report-entities";
import {AxiosInstance} from "axios";
import {BugReportFiltersDTO} from "@fenix/bug-report-entities/bug-report-entities";

export default class FeatureRequestRepository implements FeatureRequestRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  async createFeatureRequest(dto: CreateFeatureRequestDTO): Promise<FeatureRequestEntity> {
    const url = '/bug-report/features';
    const res = await this.axios.post(url, dto);

    return res.data;
  }

  async getFeatureRequest(id: number): Promise<FeatureRequestEntity> {
    const url = `/bug-report/features/${id}`;
    const res = await this.axios.get(url)

    return res.data;
  }

  async updateFeatureRequest(id: number, dto: UpdateFeatureRequestDTO): Promise<FeatureRequestEntity> {
    const url = `/bug-report/features/${id}`;
    const res = await this.axios.patch(url, dto)

    return res.data;

  }

  async deleteFeatureRequest(id: number): Promise<void> {
    const url = `/bug-report/features/${id}`;
    await this.axios.delete(url);
  }

  async getAll(page?: number, take?: number): Promise<[FeatureRequestEntity[], number]>  {
    const url = `/bug-report/features?page=${page}&take=${take}`;
    const res = await this.axios.get(url);

    return res.data;
  }

  async removeFiles(id: number, fileIds: number[]): Promise<void> {
    const url = `/bug-report/features/${id}/files`;
    const res = await this.axios.delete(url, { params: {
        ids: fileIds,
      }});

    return res.data;
  }

  async search(
    filters: BugReportFiltersDTO,
    page?: number,
    take?: number
  ): Promise<[FeatureRequestEntity[],number]> {
    if(filters.dateFrom) {
      Object.assign(filters, {dateFrom: new Date(filters.dateFrom).toISOString()})
    }
    if(filters.dateTo) {
      Object.assign(filters, {dateTo: new Date(filters.dateTo).toISOString()})
    }
    const url = `/bug-report/features/search?${this.transformDTO(filters)}&`
    const res = await this.axios.get(url, {
      params: {
        page,
        take,
      }
    })

    return res.data;
  }

  async archive(page?: number, take?: number): Promise<[FeatureRequestEntity[], number]> {
  const url = `/bug-report/features/archive?page=${page}&take=${take}`;
  const res = await this.axios.get(url);

  return res.data
  }

  public transformDTO(filters: BugReportFiltersDTO) {
    return Object.keys(filters).map((key) => {
      return `filters[${key}]=${filters[key as keyof BugReportFiltersDTO]}`
    }).join("&")
  }
}
